import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireSquadStaffMember} from '@tisa-group/models';
import {ImageVariantModule} from '@tisa-group/core';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';

@Component({
  selector: 'tisa-staff-tile',
  imports: [CommonModule, SvgIconComponent, ImageVariantModule],
  templateUrl: './staff-tile.component.html',
  styleUrl: './staff-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffTileComponent {
  staffMember = input<UmpireSquadStaffMember>();
}
